/* DON'T EDIT THIS FILE: edit original and run build again */ export const investorSignUpPath = "/inversores";
export const sgrSignUpPath = "/sgrs";
export const bankSignUpPath = "/bancos";
export const alycSignUpPath = "/alycs";
export const valueChainSignUpPath = "/cadenas-de-valor";
export const chamberSignUpPath = "/camaras";
